import React from "react";
import { Button } from "./Button";

export interface QuantitySelectorProps {
  value: number;
  min?: number;
  max?: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export const QuantitySelector: React.FC<QuantitySelectorProps> = ({
  value,
  min = 1,
  max = 999,
  onChange,
  disabled = false,
  size = "md",
  className = "",
}) => {
  const handleDecrease = () => {
    if (value > min) {
      onChange(value - 1);
    }
  };

  const handleIncrease = () => {
    if (value < max) {
      onChange(value + 1);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(e.target.value, 10);
    if (!isNaN(newValue) && newValue >= min && newValue <= max) {
      onChange(newValue);
    }
  };

  const sizeClasses = {
    sm: "h-8 text-sm",
    md: "h-10 text-base",
    lg: "h-12 text-lg",
  };

  return (
    <div
      className={`inline-flex items-center border border-gray-300 overflow-hidden ${className}`}
      style={{
        borderRadius: "var(--store-border-radius, 0.375rem)",
        borderWidth: "1px",
      }}
    >
      <Button
        variant="ghost"
        size={size}
        onClick={handleDecrease}
        disabled={disabled || value <= min}
        className="rounded-none border-r-0"
      >
        <svg
          className="h-4 w-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M20 12H4"
          />
        </svg>
      </Button>
      <input
        type="number"
        value={value}
        min={min}
        max={max}
        onChange={handleInputChange}
        disabled={disabled}
        className={`
     w-16 text-center border-0 focus:outline-none focus:ring-0
     ${sizeClasses[size]}
     disabled:bg-gray-100
    `}
      />
      <Button
        variant="ghost"
        size={size}
        onClick={handleIncrease}
        disabled={disabled || value >= max}
        className="rounded-none border-l-0"
      >
        <svg
          className="h-4 w-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 4v16m8-8H4"
          />
        </svg>
      </Button>
    </div>
  );
};

export default QuantitySelector;
